import React from "react"
import SectionHeader from "./section-header"

const WhoItWorksFor = ({ title = "Who It Works For", cards = [] }) => (
  <section className="mt-5 py-5 who-section">
    <div className="container px-5-desktop px-5-tablet">
      <SectionHeader title={title} />

      {/* Mobile */}
      <div className="is-hidden-tablet">
        <div
          className="is-flex is-flex-wrap-nowrap mt-5"
          style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
        >
          {cards.map(({ title, icon, bullets = [], gradient }, i) => {
            const isSingle = bullets.length === 1
            return (
              <div
                key={i}
                style={{
                  flex: "0 0 85%",
                  marginRight: i === cards.length - 1 ? "1rem" : "1.5rem",
                  marginLeft: i === 0 ? "1rem" : 0,
                }}
              >
                <div
                  className="px-6 py-5 is-flex is-flex-direction-column"
                  style={{
                    borderRadius: 40,
                    height: "100%",
                    background: gradient,
                  }}
                >
                  <div className="is-flex is-justify-content-flex-end">
                    <img src={icon} alt="" style={{ width: 30, height: 30 }} />
                  </div>

                  <h3 className="has-text-left has-text-weight-semibold is-size-4-mobile text-dark-blue mt-6">
                    {title}
                  </h3>

                  <ul className={`${isSingle ? "mt-2" : "mt-4"} pr-2 mb-4`}>
                    {bullets.map((b, j) => (
                      <li
                        key={j}
                        className="has-text-left text-dark-blue is-size-6 has-text-weight-light"
                        style={{
                          marginBottom: j === bullets.length - 1 ? "0" : "1rem",
                          listStyle: "none",
                          position: "relative",
                          paddingLeft: isSingle ? 0 : "1.2rem",
                        }}
                      >
                        {!isSingle && (
                          <span
                            style={{ position: "absolute", left: 0, top: 0 }}
                          >
                            •
                          </span>
                        )}
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {/* Tablet + Desktop */}
      <div className="is-hidden-mobile">
        <div className="columns is-variable is-2 is-align-items-stretch is-multiline mt-5">
          {cards.map(({ title, icon, bullets = [], gradient }, i) => {
            const isSingle = bullets.length === 1
            const desktopColClass =
              cards.length === 4
                ? "is-3-desktop is-3-tablet pt-0"
                : "is-4-desktop is-4-tablet pt-0"
            return (
              <div className={`column ${desktopColClass}`} key={i}>
                <div
                  className="who-card is-flex is-flex-direction-column"
                  style={{
                    borderRadius: 40,
                    padding: 35,
                    height: "100%",
                    background: gradient,
                  }}
                >
                  <div className="is-flex is-justify-content-flex-end">
                    <img src={icon} alt="" style={{ width: 30, height: 30 }} />
                  </div>

                  <div>
                    <h3 className="who-card__title has-text-left is-size-4-desktop has-line-height-1 has-text-weight-semibold text-dark-blue mt-6">
                      {title}
                    </h3>

                    <ul className={`${isSingle ? "mt-2" : "mt-4"} pr-2 mb-4`}>
                      {bullets.map((b, j) => (
                        <li
                          key={j}
                          className="who-card__item has-text-left text-dark-blue is-size-6 has-text-weight-light"
                          style={{
                            marginBottom:
                              j === bullets.length - 1 ? "0" : "1rem",
                            listStyle: "none",
                            position: "relative",
                            paddingLeft: isSingle ? 0 : "1.2rem",
                          }}
                        >
                          {!isSingle && (
                            <span
                              style={{ position: "absolute", left: 0, top: 0 }}
                            >
                              •
                            </span>
                          )}
                          {b}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  </section>
)

export default WhoItWorksFor
